import { create } from 'zustand'
import {  messages, messengerMessages1, messengerMessages2, messengerMessages3, messengerMessages4, messengerMessages5, messengerMessages6, messengerMessages7   } from '../dummy/messages'
import { persist, createJSONStorage } from 'zustand/middleware'

export const messengerStore = create(
  persist((set,get) => ({
        selected: 0,
        loading:'idle',
        messages:messages,
        profile:{},
        tab: 'messages',
        detail:false,
        setSelected: (selected) => set((state) => ({ selected: selected })),
        reset: () => set({ selected: 0 }),
        addMessage: (user,msg) => {
            let msgs = [...get().messages];
            let lastUser = msgs[msgs.length-1]

            if(user.me && lastUser.id == user.id){
            lastUser.messages.push(msg);
            msgs[msgs.length-1] = lastUser; 
            set({ messages: msgs })
            }else{
             set({ messages: [ ...msgs, user]  }) // , messages[2]
            }

        },
        setDetail:(detail)=> set({detail}),
        setConversation:(value)=> {
          switch (value) {
            case 0:
              return set({messages: messages})
            case 1:
                return set({messages: messengerMessages1})
            break;
            case 2:
                 return set({messages: messengerMessages2})
            break;
            case 3:
              return set({messages: messengerMessages3})
            break;
            case 4:
              return set({messages: messengerMessages4})
           break;
           case 5:
              return set({messages: messengerMessages5})
            break;
            case 6:
              return set({messages: messengerMessages6})
            break;
            case 7:
              return set({messages: messengerMessages7})
            break;
            default:
              return set({messages: []})
            break;
          }
        }
          
    }),
    {
      name: 'messenger-storage',
      storage: createJSONStorage(() => localStorage), 
    }
  )
)




export default messengerStore